import React from "react";
import Table from "./ui/Table";

const TableComponent = ({
  data,
  tableHeaders,
  tableColumns,
  handleEditClick,
  isLoading
}) => {
  return (
    <Table
      headers={tableHeaders}
      columns={tableColumns}
      data={data}
      handleEditClick={handleEditClick}
      isLoading={isLoading}
    />
  );
};

export default TableComponent;